import "@/App.css";
import { useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PaymentStatus from "@/pages/PaymentStatus";
import WhatsAppButton from "@/components/site/WhatsAppButton";

function App() {
  const lenisRef = useRef(null);
  return (
    <ReactLenis
      root
      options={{ lerp: 0.08, smoothWheel: true }}
      ref={(node) => {
        lenisRef.current = node;
        if (node?.lenis) window.__lenis = node.lenis;
      }}
    >
      <div className="App font-body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentStatus />} />
            <Route path="/payment/cancel" element={<PaymentStatus />} />
          </Routes>
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
